import { memo } from "react";
import { logOut, Tooltip, useAuthStore } from "@";

const SideBarFooter = () => {
  const { user } = useAuthStore();

  return (
    <>
      <button
        data-tooltip-placement="right"
        data-tooltip-target="sideBarFooter"
        type="button"
        onClick={logOut}
        className="sideBar-footer group relative mx-3 mb-10 mt-2 flex items-center gap-3 overflow-hidden rounded-2xl border border-gray-100 bg-white/70 p-2.5 text-start backdrop-blur-md transition-all duration-200 hover:border-purple-100 hover:bg-white hover:shadow-sm hover:shadow-purple-900/5 dark:border-gray-800/70 dark:bg-gray-900/40 dark:hover:border-purple-900/40 dark:hover:bg-gray-900/80 lg:mb-5 lg:mt-5"
      >
        {/* Avatar */}
        <span className="relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/20 ring-1 ring-white/40 dark:from-purple-600 dark:to-purple-800 dark:ring-gray-900/40">
          <span className="text-sm font-semibold uppercase tracking-wide">
            {user?.displayName?.substring(0, 2)}
          </span>
          {/* Online status dot */}
          <span className="absolute -bottom-0.5 -end-0.5 h-3 w-3 rounded-2xl border-2 border-white bg-emerald-500 shadow-sm dark:border-gray-900" />
        </span>

        {/* User info */}
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-[13px] font-semibold tracking-tight text-gray-900 dark:text-gray-200">
            {user?.displayName}
          </h3>
          <p className="truncate text-[11px] text-gray-500 dark:text-gray-400">
            {user?.email}
          </p>
        </div>

        {/* Logout icon — visible on hover */}
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-2xl bg-gray-50 text-gray-400 transition-colors group-hover:bg-red-50 group-hover:text-red-500 dark:bg-gray-800 dark:text-gray-500 dark:group-hover:bg-red-950/40 dark:group-hover:text-red-400">
          <svg
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke="currentColor"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12.5 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V4.16667C17.5 3.72464 17.3244 3.30072 17.0118 2.98816C16.6993 2.67559 16.2754 2.5 15.8333 2.5H12.5M6.66667 14.1667L2.5 10M2.5 10L6.66667 5.83333M2.5 10H12.5"
            />
          </svg>
        </span>
      </button>
      <Tooltip title="تسجيل خروج" id="sideBarFooter" />
    </>
  );
};

export default memo(SideBarFooter);
